import { useWindowDimensions } from 'react-native';

const useScreenSize = () => {
  const dimensions = useWindowDimensions();
  const isLargeScreen = dimensions.width >= 992;
  const isMediumScreen = dimensions.width >= 768;
  return {
    isLargeScreen,
    isMediumScreen,
    screenWidth: dimensions.width,
    screenHeight: dimensions.height
  };
};

export { useScreenSize as u };
